import React,{useState} from "react";
import Layout from "../../NewComponent/Layout/Layout";
import Form from "./Form";
import DownloadAttachment from "../../Component/DownloadAttachment/DownloadAttachment";
import MyDownload from "../../Component/myDownload/myDownload";

export default function DownloadPage() {
  const containerStyles = {
    width: "80%",
    margin: "auto",
    marginTop: "1%",
    marginBottom: "7%",
    border: '1px solid #EAECF0',
    boxShadow: '0px 4px 16px 0px #1018280F',
    borderRadius:'12px',
    // minHeight:'450px',
    padding:'24px'

  };
  return (
    <Layout>
      <div style={containerStyles}>
        <Form/>
        <DownloadAttachment/>
        <MyDownload/>
      </div>
    </Layout>
  );
}
